import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useDrive } from "../context/DriveContext";
import { GoogleLogo, ArrowRight, CheckSquare, Lightning } from "@phosphor-icons/react";

export default function ConnectPage() {
  const { connected, checking, login } = useDrive();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    if (params.get("drive_connected") === "true") {
      toast.success("Google Drive подключён");
    }
    const err = params.get("drive_error");
    if (err) toast.error(`Ошибка подключения: ${err}`);
  }, [params]);

  useEffect(() => {
    if (!checking && connected) {
      navigate("/prices/add", { replace: true });
    }
  }, [checking, connected, navigate]);

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left: cover */}
      <div
        className="hidden lg:block relative bg-cover bg-center border-r border-[#18181b]"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1755018237558-5f9edc544504?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwd2hpdGUlMjBhcmNoaXRlY3R1cmUlMjBnZW9tZXRyaWN8ZW58MHx8fHwxNzc2ODkyODMyfDA&ixlib=rb-4.1.0&q=85)",
        }}
      >
        <div className="absolute inset-0 bg-white/10" />
        <div className="relative h-full flex flex-col justify-between p-10">
          <div className="mono-label text-[#0a0a0a] bg-white/80 backdrop-blur-sm px-2 py-1 inline-block w-fit">
            PRICE AGGREGATOR / 01
          </div>
          <div className="bg-white border border-[#18181b] p-6 max-w-md hard-shadow">
            <h2 className="text-xl font-semibold tracking-tight">
              Один интерфейс.<br />Все ваши прайс-листы.
            </h2>
            <p className="text-sm text-[#52525b] mt-3">
              Подключите Google Drive — и добавляйте новые позиции сразу в нужные
              файлы разных маркетплейсов. Без правки каждого вручную.
            </p>
          </div>
        </div>
      </div>

      {/* Right: auth */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="mono-label mb-3">ШАГ 01 / ПОДКЛЮЧЕНИЕ</div>
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight leading-tight">
            Подключите<br />Google Drive
          </h1>
          <p className="text-sm text-[#52525b] mt-4 max-w-sm">
            Нужен доступ, чтобы приложение могло читать структуру папок-сайтов и
            дописывать новые строки в ваши прайс-листы (<span className="font-mono">.xls / .xlsx / .csv</span>).
          </p>

          <div className="mt-8 space-y-3">
            {[
              "Читать и изменять ваши прайсы на Drive",
              "Работать автономно после первого входа",
              "Вы можете отключить доступ в любой момент",
            ].map((t) => (
              <div key={t} className="flex items-start gap-3 text-sm">
                <CheckSquare size={18} weight="bold" className="text-[#0047FF] mt-0.5" />
                <span>{t}</span>
              </div>
            ))}
          </div>

          <button
            onClick={login}
            data-testid="drive-oauth-connect"
            className="mt-8 w-full flex items-center justify-center gap-2 bg-[#0047FF] text-white px-5 py-3 text-sm font-medium hover:bg-[#0036CC] transition-colors duration-150"
          >
            <GoogleLogo size={18} weight="bold" />
            <span>Войти через Google</span>
            <ArrowRight size={16} weight="bold" />
          </button>

          <div className="mt-6 flex items-center gap-2 text-xs text-[#52525b]">
            <Lightning size={14} weight="bold" />
            <span>
              Запрашиваемый scope:{" "}
              <code className="mono bg-[#e7e7e4] px-1.5 py-0.5">
                drive
              </code>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
